import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
class TicketModalUploadButton extends Vue {

  private _clearTimeout: any;
  dtDocumentConfigs: { minimum: number, image: { alpha: number }, video: { alpha: number }, document: { alpha: number } }
  dtButonHeight: number | null
  dtUploadButtons: {
    type: string;
    icon: string;
    translationKey: string;
    acceptedType: string;
  }[];
  dtFileError: boolean;
  dtError: any;
  get lblSetting() {
    return {
      ...require('../../../../locales/generic-labels').default
    }
  }

  @Prop({ default: () => [], type: [Object, Array] })
  value: any;

  @Prop({ default: null, type: [Array] })
  buttons: { type: string; icon: string; translationKey: string; acceptedType: string; }[];
  @Prop({ default: null, type: [Object], required: false })
  creator: Object | null


  @Prop({ default: '', type: [String], required: false })
  customClass: string

  @Prop({ default: false, type: [Boolean] })
  disabled: boolean;
  /**
   *
   */
  constructor() {
    super();
    this.dtDocumentConfigs = require('../../../../configs/ticket-document-maxsize.config.json');
    this.dtButonHeight = 76.5;
    this.dtError = null;
    this.dtFileError = false;
  }

  get coButtons() {
    if (this.buttons) {
      return this.buttons;
    }
    return [
      { type: 'image', icon: 'icon-photo', translationKey: this.lblSetting.lblPhoto, acceptedType: 'image/*' },
      { type: 'file', icon: 'icon-video', translationKey: this.lblSetting.lblVideo, acceptedType: 'video/*' },
      { type: 'document', icon: 'icon-quote', translationKey: this.lblSetting.lblDocument, acceptedType: '.xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf' }
    ]
  }
  get vModel(): any[] { return this.value; }
  set vModel(value: any[]) { this.$emit('input', value); }

  handleUpload(type: string) {
    (this.$refs[type][0] as any).click();
  }
  getButtonStyle(refName: string) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(async () => {
      if (this.$refs[refName][0]) {
        const ele = this.$refs[refName][0].$el;
        this.dtButonHeight = (ele.clientWidth - (ele.clientWidth * 8) / 100);
      }
    }, 10);
    return {
      height: `calc(${this.dtButonHeight}px)`
    };
  }


  async handleAddFile({ files }, type: string, icon: string, index: number) {
    if (files.length === 0) return;

    for (let fIndex: number = 0; fIndex < files.length; fIndex++) {
      await this.getBase64URL(files[fIndex])
        .then((fileReader: FileReader) => {

          const file = files[fIndex];
          file.id = `${file.lastModified}-${this.vModel.length}`;
          file.customType = type;
          file.icon = icon;
          fileReader.onloadend = () => {
            file.url = fileReader.result;
          }
          file.percentage = 0;
          file.fakeId = `${new Date().getTime()}-${file.size}-${fIndex}`;
          file.loader_id = `${new Date().getTime()}-${file.size}-${fIndex}`;
          if (this.creator) {
            file.creator = this.creator;
          }
          return Promise.resolve(file)
        })
        .then(file => {
          setTimeout(() => this.vModel.push(file), 100);
        })
        .then(() => this.handleResetForm(type, index))
        .catch(error => console.log(error))
    }

  }
  async handleRemoveFile(file: any, index: number, type: string) {
    this.vModel = this.vModel.filter(item => item.id !== file.id);
  }

  handleResetForm(type: string, index: number) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      const form = this.$refs[`form- ${type}-${index}`] as any;
      if (form) {
        form[0].reset();
      }
    }, 100)
  }
  private async getBase64URL(file): Promise<FileReader> {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    return Promise.resolve(fileReader);
  }
  private calculateMaxSize(type): number {
    return this.dtDocumentConfigs[type].alpha * this.dtDocumentConfigs.minimum
  }
  private validateFileSize(size: number, type: string) {
    return size < this.calculateMaxSize(type);
  }

  handleHideError() {
    this.dtError = null;
    this.dtFileError = false;
  }
}

export default TicketModalUploadButton;



// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-modal-upload-buttons/index.ts